import { defaultFooterNavigationSchema, defaultSupportNavigationSchema } from '../../defaults/schema';
import { caoWijzerAdminNavigationSchema, caoWijzerUserNavigationSchema } from './schema';
import { DefaultNavigationStrategy } from '../../defaults/strategy';

export class CaoWijzerLabelStrategy extends DefaultNavigationStrategy {
	override getSchema = () => {
		return {
			userNavigationItems: caoWijzerUserNavigationSchema,
			adminNavigationItems: caoWijzerAdminNavigationSchema,
			supportNavigationItems: defaultSupportNavigationSchema,
			footerNavigationItems: defaultFooterNavigationSchema,
		};
	};
}
